import dayjs from 'dayjs';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { backend } from '../axios/backend';
import ChatBubbleOutline from '../components/icons/ChatBubbleOutline';
import DocumentDuplicateOutline from '../components/icons/DocumentDuplicateOutline';
import EnvelopeOutline from '../components/icons/EnvelopeOutline';
import PrettyLoader from '../components/PrettyLoader';
import ShareItem from '../components/ShareItem';
import { useAppContext } from '../context/AppContext';

type SharedWithMe = {
  sharedAt: Date;
  id: string;
  sharedBy?: {
    id: string;
    firstname: string;
    lastname: string;
  };
};

const shareText =
  'Hey! Ich habe diese coole App entdeckt um Wünsche festzuhalten, mit Familie und Freunden zu teilen und Geschenkideen für Andere zu teilen. https://mt-bringsl.de';

const SharedWithMeOverviewPage = () => {
  const { alertSuccess } = useAppContext();
  const navigate = useNavigate();

  const query = useQuery(
    ['shared-with-me'],
    async () => (await backend.get<SharedWithMe[]>('wish/shared-with-me')).data,
  );

  return (
    <div style={{ margin: '2rem' }}>
      <h1 className="text-white text-xl">
        <b>Mit mir geteilt</b>
      </h1>
      <PrettyLoader useQueryResult={query}>
        {query.data?.length === 0 && (
          <div className="mt-2 text-white space-y-4">
            <p>Es hat noch niemand seine Wünsche mit dir geteilt 🙁</p>
            <p>Empfehle MtBringsl jetzt deinen Freunden:</p>
            <div className="grid grid-cols-3 md:grid-cols-4 gap-6 max-w-sm pt-4">
              <ShareItem
                name="Whatsapp"
                Icon={<ChatBubbleOutline className="w-8 h-8 text-lime-700" />}
                onClick={() => {
                  if (!query.data) return;
                  const params = new URLSearchParams('');
                  params.append('text', shareText);
                  const url = `https://wa.me?${params.toString()}`;
                  window.open(url, '_blank');
                }}
              />
              <ShareItem
                name="Email"
                Icon={<EnvelopeOutline className="w-8 h-8 text-gray-700" />}
                onClick={() => {
                  if (!query.data) return;
                  const text = shareText.replaceAll('\n', '%0D%0A');
                  const url = `mailto:?to=&subject=MtBringsl&body=${text}`;
                  window.open(url, '_blank');
                }}
              />
              <ShareItem
                name="Text"
                Icon={<DocumentDuplicateOutline className="w-8 h-8 text-gray-700" />}
                onClick={() => {
                  if (!query.data) return;
                  const text = shareText;
                  navigator.clipboard.writeText(text);
                  alertSuccess('Text in die Zwischenablage kopiert.');
                }}
              />
            </div>
          </div>
        )}
        <ul className="divide-y divide-gray-400 mb-4">
          {query.data?.map((sharedWithMe) => (
            <li
              key={sharedWithMe.id}
              className="py-4 flex flex-row space-x-4 items-center cursor-pointer"
              onClick={() => navigate(`/shared-wishes/${sharedWithMe.id}`)}
            >
              <span className="flex flex-col h-10 w-10 bg-white rounded-full justify-center text-center">
                {sharedWithMe.sharedBy?.firstname[0]}
              </span>
              <div>
                <p className="text-white">
                  {sharedWithMe.sharedBy?.firstname} {sharedWithMe.sharedBy?.lastname}
                </p>
                <p className="text-gray-400 text-sm">{dayjs(sharedWithMe.sharedAt).format('DD.MM.YYYY HH:mm [Uhr]')}</p>
              </div>
            </li>
          ))}
        </ul>
      </PrettyLoader>
    </div>
  );
};

export default SharedWithMeOverviewPage;
